import React from "react";
import { Link } from 'react-router-dom'
import { BlueButton } from "~/components/pages/features/components/blue-button";
import { AmplitudeCounter } from "~/amplitude-counter";
import { Styled } from './styled'

interface DescriptionMobileProps {
  title: string;
  text: string[];
  linkIOS: string,
  linkAndroid: string;
  link?: string;
}

const DescriptionMobile = (props: DescriptionMobileProps) => {
  return (
    <Styled.Container>
      <Styled.Title>{props.title}</Styled.Title>
      <Styled.List>
        {props.text.map((item) => (
          <Styled.Text>{item}</Styled.Text>
        ))}
      </Styled.List>
      <Link to={props.link} >
        <BlueButton text={'Подробнее'}/>
      </Link>
      <Styled.Badges>
        <Styled.Badge>
          <a
            href={props.linkIOS}
            target='_blank'
            onClick={() => AmplitudeCounter('click_download_mobile', { service: 'AppStore' })}
          >
            <img src={process.env.PUBLIC_DIR + '/images/app-store-badge-black.svg'} />
          </a>
        </Styled.Badge>
        <Styled.Badge>
          <a
            href={props.linkAndroid}
            target='_blank'
            onClick={() => AmplitudeCounter('click_download_mobile', { service: 'GooglePlay' })}
          >
            <img src={process.env.PUBLIC_DIR + '/images/google-play-badge-black.svg'} />
          </a>
        </Styled.Badge>
      </Styled.Badges>
    </Styled.Container>
  )
}

export default DescriptionMobile
